const PREFIX = '[NCare LIFF]';

function isDebugEnabled() {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    if (window.localStorage?.getItem('ncare-liff-debug') === '1') {
      return true;
    }
  } catch {
    // ignore private mode / blocked storage
  }

  const params = new URLSearchParams(window.location.search);
  return params.get('debug') === '1' || params.get('vconsole') === '1';
}

export function enableVConsoleIfDebug() {
  if (!isDebugEnabled() || typeof window === 'undefined') {
    return;
  }

  if (window.__ncareVConsole) {
    return;
  }

  import('vconsole').then(({ default: VConsole }) => {
    window.__ncareVConsole = new VConsole({ theme: 'dark' });
    console.info(`${PREFIX} VConsole enabled (?debug=1 or localStorage ncare-liff-debug=1)`);
  });
}

function log(level, message, detail) {
  const fn = console[level] ?? console.log;
  if (detail !== undefined) {
    fn(`${PREFIX} ${message}`, detail);
  } else {
    fn(`${PREFIX} ${message}`);
  }
}

export const liffLog = {
  debug(message, detail) {
    log('debug', message, detail);
  },
  info(message, detail) {
    log('info', message, detail);
  },
  warn(message, detail) {
    log('warn', message, detail);
  },
  error(message, detail) {
    log('error', message, detail);
  },
  snapshot() {
    if (typeof window === 'undefined' || !window.liff) {
      return { liffLoaded: false };
    }

    return {
      liffLoaded: true,
      isInClient: window.liff.isInClient?.(),
      isLoggedIn: window.liff.isLoggedIn?.(),
      os: window.liff.getOS?.(),
      language: window.liff.getLanguage?.(),
      version: window.liff.getVersion?.(),
      lineVersion: window.liff.getLineVersion?.(),
      context: window.liff.getContext?.(),
    };
  },
};
